<template>
	<div class="checkbox-container">
		<b-form-checkbox :id="`staff${data.checkbox.id}`" v-model="checked" :value="true" :unchecked-value="false" @change.native="onCheckboxClick(data.checkbox.emit)" />
	</div>
</template>

<script>
	import { bus } from './../../main';

	export default {
		name: 'CheckboxColumn',
		props: {
			data: {}
		},
		data() {
			return {
				checked: false
			}
		},
		mounted() {
			this.checked = this.data.checkbox.checked
		},
		watch: {
			data: {
				immediate: true,
				handler(newValue, oldValue) {
					this.checked = newValue.checkbox.checked
				}
			}
		},
		methods: {
			onCheckboxClick: function (emit) {
				var obj = JSON.parse(JSON.stringify(this.data))
				obj.checkbox.checked = this.checked

				bus.$emit(emit, obj)
			}
		}
	}
</script>

<style scoped>
	.checkbox-container .custom-control {
		display: inline-block;
		padding-left: 0;
	}

	.checkbox-container .custom-control-label::before,
	.checkbox-container .custom-control-label::after {
		z-index: 0;
	}
</style>